module.exports = __webpack_public_path__ + "static/market_about_logo-bffcef44f75158c3e516da1ef972f7e6.png";